import { useEffect, useState } from "react";
import { CollectionsContentsView } from "../components/CollectionsContentView";
import { CollectionIcon } from "../icon_templates/icons";
import  {SingleInputModal}  from "../components/SingleInputModal";
import { useDispatch, useSelector } from "react-redux";
import { setCollectionId } from "../common_functions/slicers";
import * as bootstrap from 'bootstrap';
import { createNewCollection, get_all_collections, delete_collection, getCollectionSchema } from "../assets/constants/global_apis";
import { ConfirmationModal } from "../components/ConfirmationModal";
import FileAnnotator from "../components/FileAnnotator";
import { Box, Modal } from "@mui/material";
import { sortObjectArrayByKey } from "../common_functions/video_annotator_functions";
const style = {
  position: 'absolute',
  top: '0%',
  width: '100%',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  padding: '0px'
};


export default function Collections() {
  const [collections, setCollections] = useState([]);
  const [selected_collection, setSelectedCollection] = useState('');
  const [showCollectionView, setShowCollectionView] = useState(false);
  const [fileAnnotatorOpen, setFileAnnotatorOpen] = useState(false)
  const [schemaJsonList, setSchemaJsonList] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const [request, setRequest] = useState({
    label: ""
  });
  const collectionId = useSelector(state => state.collections.collectionId);
  const [buttonAction, setbuttonAction] = useState({
    backend: {},
    event: '',
    index: -1,
    eventMessage: ''
  })
  const [open, setOpen] = useState(false);

  const handleOpenFileAnnotator = () => {
    setFileAnnotatorOpen(true);
  };
  const handleCloseFileAnnotator = () => {
    setFileAnnotatorOpen(false);
  };


  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setbuttonAction({
      backend: {},
      event: '',
      index: -1,
      eventMessage: ''
    });
    setOpen(false);
  };

  const handleButtonEventRemoveDelete = (event, e, collection, collectionid) => {
    e.stopPropagation();
    setbuttonAction({
      collection: collection,
      event: event,
      id: collectionid,
      eventMessage: <span>Are you sure you want to delete <b>{collection.label}</b>?</span>
    });
    handleOpen();
  }

  const handleSubmitConfirmation = (event) => {
    if (buttonAction.event == 'Delete') {
      delete_the_collection(buttonAction.id)
    }
    setShowCollectionView(false);
    setSelectedCollection(buttonAction.collection);
    handleClose();
  }

  const closeModal = () => {
    var myModalEl = document.getElementById('createCollectionModal');
    var modal = bootstrap.Modal.getInstance(myModalEl)
    modal.hide();
  }
  const create_new_collection = (event) => {
    event.preventDefault();
    createNewCollection(request).then(data => {
      console.log(data);
      closeModal();
      setRequest({
        label: ""
      });
      get_all_the_collections_data(); // get_all_the_collections_data();
    })
  }
  const get_all_the_collections_data = () => {
    get_all_collections().then(data => {
      setCollections(data);
      console.log(data);
    })
      .catch(error => console.log(error));
  }

  const delete_the_collection = (collection_Id) => {
    delete_collection(collection_Id).then(data => {
      console.log(data);
      get_all_the_collections_data();
    })
      .catch(error => console.log(error));
  }


  const filterCollections = (e) => {
    console.log(e.target.value);
    if (e.target.value !== "") {
      let filteredCollections = collections.filter((collection) => collection.label.toLowerCase().includes(e.target.value.toLowerCase()));
      setCollections(filteredCollections);
    } else {
      get_all_the_collections_data();
    }
  }
  useEffect(() => {
    get_all_the_collections_data();
    dispatch(setCollectionId(''))
  }, [])
  useEffect(() => {
    getCollectionSchemaData(collectionId)
  }, [collectionId])
  const getCollectionSchemaData = (collection_id) => {
    if(collection_id && collection_id !== '') {
    getCollectionSchema(collection_id).then((schemaData) => {
      if (schemaData?.schema && schemaData.schema.length > 0) {
        let sortedSchema = sortObjectArrayByKey(schemaData.schema, "schema_id", "asc")
        setSchemaJsonList(sortedSchema);
      } else {
        setSchemaJsonList([]);
      }
    }).catch((error) => {
      console.log('Error fetching schema:', error.message);
    });
  }
  }


  return (
    <div className='container-fluid g-2'>
      <div className='row g-2'>
        <div className='col-md-3'>
          <div style={{ backgroundColor: "#f8f9fa" }} className='mt-0'>
            <div className='card h-100 rounded-0  border-top-0 border-bottom-0 border-start-0 bg-transparent'>
              <div className='card-header d-flex align-items-center justify-content-between'>
                <input
                  type='text'
                  className='form-control me-2'
                  placeholder='Search collections'
                  style={{ width: "100%" }}
                  onChange={(e) => filterCollections(e)}
                />
              </div>
              <button
                      className='btn btn-sm btn-dark create-new-button mt-2 me-3 mb-1 ms-3'
                      data-bs-toggle='modal'
                      data-bs-target='#createCollectionModal'
                    >
                      Create collection
                    </button>
              <div className='card-body p-0'>
                <div
                  style={{ height: "calc(100vh - 115px)", overflow: "auto" }}
                >
                  <div className='collectionPane border-0'>
                    {collections && collections.length > 0
                      ? collections.map((collection, index) => (
                          <div
                            className={
                              collection.id === collectionId
                                ? "d-flex justify-content-between align-items-center collection-lists active"
                                : "d-flex justify-content-between align-items-center collection-lists"
                            }
                            key={index}
                            onClick={() => {
                              dispatch(setCollectionId(collection.id));
                              setSelectedCollection(collection.id);
                              setShowCollectionView(true);
                            }}
                          >
                            <div
                              title={collection.label}
                              style={{
                                wordWrap: "break-word",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "80%",
                              }}
                            >
                              <CollectionIcon />
                              {collection.label}
                            </div>
                            <button
                              className='btn btn-sm btn-danger delete-button'
                              onClick={(e) =>
                                handleButtonEventRemoveDelete(
                                  "Delete",
                                  e,
                                  collection,
                                  collection.id
                                )
                              }
                              title='Delete collection'
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                fill='none'
                                viewBox='0 0 24 24'
                                strokeWidth={1.5}
                                stroke='#fff'
                                className='size-6'
                              >
                                <path
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                  d='m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0'
                                />
                              </svg>
                            </button>
                          </div>
                        ))
                      : "No data available"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmationModal
          isThisCenterAligned={true}
          buttonAction={buttonAction}
          open={open}
          handleClose={handleClose}
          handleSubmitConfirmation={handleSubmitConfirmation}
        />
        <div className='col-md-9'>
          {showCollectionView && (
            <CollectionsContentsView
              handleOpenFileAnnotator={handleOpenFileAnnotator}
              handleCloseFileAnnotator={handleCloseFileAnnotator}
              isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}
            />
          )}
          <SingleInputModal
            requestpayload={request}
            setRequestPayload={setRequest}
            handleSubmit={create_new_collection}
            handleClose={closeModal}
            popupType={"Collection"}
          />
        </div>
      </div>
      <Modal
        open={fileAnnotatorOpen}
        handleClose={handleCloseFileAnnotator}
        aria-labelledby='child-modal-title'
        aria-describedby='child-modal-description'
        className='cvatModalContainer'
      >
        <Box sx={{ ...style }}>
          <FileAnnotator
            handleCloseFileAnnotator={handleCloseFileAnnotator}
            fileAnnotatorOpen={fileAnnotatorOpen}
            collectionId={collectionId}
            schemaJsonList={schemaJsonList}
            setSchemaJsonList={setSchemaJsonList}
            getCollectionSchemaData={getCollectionSchemaData}
          />
        </Box>
      </Modal>
    </div>
  );
};
